export default "__VITE_ASSET__DHE5nh0c__"